import "./MarketHoursWarningComponent.scss";
import {CurrentUserService} from "../../../../../../../services/user/CurrentUserService";
import {IOnInit} from "angular";
import {MarketUtil} from "../../../../../../../js/util/MarketUtil";

export const MarketHoursWarning = "marketHoursWarning";

export function marketHoursWarning() {
    return {
        templateUrl: "app/portfolio/templates/ticket/place-order-wizard/steps/confirm/market-hours/MarketHoursWarningComponent.html",
        controllerAs: "ctrl",
        controller: MarketHoursWarningComponentController
    };
}

export class MarketHoursWarningComponentController implements IOnInit {

    public isGame: boolean;
    public marketOpen: boolean;

    /** @ngInject */
    public constructor(private currentUserService: CurrentUserService) {

    }

    public $onInit(): void {
        this.isGame = this.currentUserService.isGame();
        this.marketOpen = MarketUtil.marketIsOpen();
    }
}
